import Stack from "@mui/material/Stack"
import Link from "next/link"
import useCategoryShallowLink from "@components/_hooks/CSRHooks/useCategoryShallowLink"
import Chip from "@mui/material/Chip"
import { useRouter } from "next/router"

const SubCategoryList = ({ sons }) => {
    const { handleShallowLink } = useCategoryShallowLink();
    const router = useRouter();
    const { query } = router;

    return (
        <Stack direction="row" className="pl-2 mobile-mb-3 mobile-mt-1" columnGap={1} rowGap={1}>
            {sons.map((son, idx) => {
                return son.visible == 'yes' && (
                    <Link className="pointer" shallow={true} scroll={false} onClick={(e) => handleShallowLink(e, son.slug)} key={idx} href={`/${son.slug}`}>
                        <Chip className="pointer" as="button" label={son.name} color="primary" variant={query?.route == son.slug ? "contained" : "outlined"}
                            sx={{
                                ':hover': {
                                    backgroundColor: 'primary.main',
                                    color: 'primary.contrastText',
                                }
                            }}
                        />
                    </Link>
                )
            })}
        </Stack>
    )
}

export default SubCategoryList